module.exports = __webpack_public_path__ + "img/swiper_introduce_03.cf065759.png";